<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y0L41S/tc-custom/9781429996280.jpg?1733027032822" alt="This image is the cover for the book What Is Life?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Is Life?
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1944, the Nobel Prize–winning physicist Erwin Schrödinger published a groundbreaking little book called <i>What Is Life? </i>In fewer than one hundred pages, he argued that life was not a mysterious or inexplicable phenomenon, as many people believed, but a scientific process like any other, ultimately explainable by the laws of physics and chemistry. <br/><br/>Today, more than sixty years later, members of a new generation of scientists are attempting to create life from the ground up. Science has moved forward in leaps and bounds since Schrödinger's time, but our understanding of what does and does not constitute life has only grown more complex. An era that has already seen computer chip–implanted human brains, genetically engineered organisms, genetically modified foods, cloned mammals, and brain-dead humans kept "alive" by machines is one that demands fresh thinking about the concept of life.<br/><br/>While a segment of our national debate remains stubbornly mired in moral quandaries over abortion, euthanasia, and other "right to life" issues, the science writer Ed Regis demonstrates how science can and does provide us with a detailed understanding of the nature of life. Written in a lively and accessible style, and synthesizing a wide range of contemporary research, <i>What Is Life? </i>is a brief and illuminating contribution to an age-old debate.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ed Regis
      </h2>
      
      <p class="authorDescription body article"><P>Ed Regis, who holds a PhD in philosophy from New York University, is a full-time science writer, contributing to <I>Scientific American</I>, <I>Harper's Magazine</I>, <I>Wired</I>, <I>Discover</I>, and <I>The New York Times</I>, among other periodicals. He is the author of several books, including <I>The Biology of Doom</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49110aa0